import { useDispatch, useSelector } from 'react-redux'
import { SelectCustom } from '../../../../../../../common/selectCustom'
import { SORT_BY } from '../../../constant'
import { changeSortBy, selectSortBy } from '../../store/slice'

export const SortBySelect = () => {
  const dispatch = useDispatch()

  const sortBy = useSelector(selectSortBy)

  const chooseItem = (item) => {
    dispatch(changeSortBy(item))
  }

  return (
    <SelectCustom
      isBorderNone
      className="fw600"
      activeItem={sortBy}
      data={Object.values(SORT_BY)}
      isI18n={true}
      chooseItem={chooseItem}
    />
  )
}
